import { rem } from 'polished';
import styled from 'styled-components';

export const ModalContent = styled.div`
  background: ${({ theme }) => theme.colors.modal.background};
  padding: ${rem(32)};

  svg {
    position: relative;
    top: ${rem(3)};
    margin-right: ${rem(8)};
  }

  h2 {
    font-size: ${rem(24)};
    font-weight: 600;
    margin-bottom: ${rem(24)};
  }

  p {
    margin-bottom: ${rem(12)};
    font-size: ${rem(16)};

    &.title {
      font-weight: 500;
    }
  }

  ul {
    margin: 0 0 ${rem(24)} ${rem(20)};
    padding: 0;
  }

  li {
    margin-bottom: ${rem(6)};
    font-size: ${rem(14)};
  }

  aside {
    background: ${({ theme }) => theme.colors.modal.aside.background};
    margin-top: ${rem(32)};
    padding: ${rem(16)};
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    border-radius: ${rem(12)};

    p {
      margin: 0;
      font-size: ${rem(14)};
      line-height: 140%;
    }

    a {
      margin-left: ${rem(20)};
      padding-right: ${rem(16)};
      padding-left: ${rem(16)};
      flex: 1 0 auto;
    }

    svg {
      margin-right: ${rem(6)};
    }
  }
`;
